import * as React from "react";
const ClusterMarker = (props) => {
    return React.createElement("div", { className: "cluster-marker", onClick: () => {
            //(document as any).getElementById(`${props.markerText}`).scrollIntoView();
            let { lat, lng } = props;
            props.clusterMarkerClick({ lat, lng });
        } },
        React.createElement("span", null, props.numberOfPoints));
};
export default ClusterMarker;
//# sourceMappingURL=cluster-marker.js.map